import { getPriceCent, getPriceFromCent } from '../../util/price';

import { getSessionType, getSessionOption } from '../Session/SessionActions';
import { getApplicantTimePassed } from '../Applicant/ApplicantActions';


export function getCreditTypes() {
    return ['exam', 'live'];
}

export function getCredit(institution, creditType) {
    if(institution.credits && institution.credits.length) {
        return institution.credits.find(credit => credit.type === creditType) || {};
    }
    return {};
}

export function getCreditValue(institution, creditType) {
    const credit = getCredit(institution, creditType);
    if(credit && credit.isUnlimited) {
        return '*';
    }
    return credit && credit.value ? credit.value : 0;
}

export function getPriceTypes() {
    return ['taxRate', 'exam', 'live', 'subject', 'chat', 'examCapture', 'sessionSchedule', 'recording', 'liveWithExam', 'liveProctored'];
}

export function getDefaultPriceValues() {
    return {
        taxRate: 0.2,
        exam: 0.5,
        live: 4,
        subject: 50,
        chat: 10,
        examCapture: 0.4,
        recording: 1,
        sessionSchedule: 0.3,
        liveWithExam: 0.7,
        liveProctored: 4,
    };
}

export function getPrice(institution, priceType) {
    if(institution && institution.pricing && institution.pricing.length) {
        return institution.pricing.find(price => price.type === priceType) || {};
    }
    return {};
}

export function getPriceValue(institution, priceType) {
    const price = getPrice(institution, priceType);
    return price && price.value ? price.value : 0;
}

export function getSessionCredits(institution, session, applicants, isScheduledByOwner = false, isSubjectHandled = false, isExternalChat = false, isProctoredByOwner = false) {
    let base = 0;
    let total = 0;

    const sessionType = getSessionType(session);
    console.log('Session type', sessionType);

    if(sessionType.includes('exam')) {
        base = getPriceValue(institution, 'exam');
    } else if(sessionType.includes('live')) {
        base = getPriceValue(institution, 'live');
        if(sessionType === 'livequeue') {
            base += getPriceValue(institution, 'recording');
        }
        if(session.subject) {
            base += getPriceValue(institution, 'liveWithExam');
        }
        if(isProctoredByOwner) {
            base += getPriceValue(institution, 'liveProctored');
        }
    }

    console.log(`Base at step 1: ${base}`);

    if(isScheduledByOwner) {
        base += getPriceValue(institution, 'sessionSchedule');
    }

    if(session.subject && getSessionOption(session, 'hasWebcamCapture')) {
        base += getPriceValue(institution, 'examCapture');
    }


    console.log(`Base at step 2: ${base}`);

    if(session.subject && isSubjectHandled) {
        total += getPriceCent(getPriceValue(institution, 'subject'));
    }

    if(getSessionOption(session, 'supportLiveChat')) {
        total += getPriceCent(getPriceValue(institution, 'chat') / (isExternalChat ? 2 : 1));
    }
    console.log(`Base at step 3: ${base}`);

    // Force hourly count for lives
    const isHourly = sessionType.includes('live');

    let deductCount =
        isHourly
        ? Math.round(applicants.map(applicant => getApplicantTimePassed(session, applicant)).reduce((totalHours, hours) => totalHours + hours, 0) * 100, 2) / 100
        : applicants.length;


    // Count proctors media duration in case of thesis
    if(sessionType.includes('thesis')) {
        deductCount += (session.proctors || []).reduce((count, proctorId) => {
            const proctorTracks = (session.proctorsTracks || []).filter(track => track.proctor === proctorId);
            const maxPassedByMedia = {};
            let maxDuration = 0;
            proctorTracks.forEach(proctorTrack => {
                if(!maxPassedByMedia[proctorTrack.name]) {
                    maxPassedByMedia[proctorTrack.name] = 0;
                }
                maxPassedByMedia[proctorTrack.name] += proctorTrack.duration;
            });
            Object.keys(maxPassedByMedia).forEach(type => {
                if(maxPassedByMedia[type] > maxDuration) {
                    maxDuration = maxPassedByMedia[type];
                }
            });
            return count + (maxDuration / 60);
        }, 0);
    }

    console.log(`Session credits: ${base} * ${deductCount} = ${base * deductCount}`);

    total += getPriceCent(deductCount) * base;

    return getPriceFromCent(total);
}
